import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

export type CtaLink = Readonly<{ href: string; label: TranslationKey; dataQa: string }>;

type Props = Readonly<{
	heading: TranslationKey;
	body: TranslationKey;
	primary: CtaLink;
	secondary: CtaLink;
}>;

/** The page-closing section: a centered heading and body over a primary and a secondary link button. */
export const ClosingCta: React.FC<Props> = ({ heading, body, primary, secondary }) => {
	return (
		<section className="container flex flex-col items-center gap-5 pb-16 text-center md:pb-32">
			<Text as="h2" variant="heading" size="x-large" fontWeight="bold">
				<TypedTranslate value={heading} />
			</Text>
			<Text as="p" variant="body" size="large" className="text-typography-weak mx-auto max-w-xl">
				<TypedTranslate value={body} />
			</Text>
			<div className="mt-3 flex w-full flex-col justify-center gap-3 md:w-auto md:flex-row">
				<Button
					as="a"
					href={primary.href}
					variant="primary"
					size="large"
					className="w-full md:w-auto"
					data-qa={primary.dataQa}
				>
					<TypedTranslate value={primary.label} />
				</Button>
				<Button
					as="a"
					href={secondary.href}
					variant="secondary"
					size="large"
					className="w-full md:w-auto"
					data-qa={secondary.dataQa}
				>
					<TypedTranslate value={secondary.label} />
				</Button>
			</div>
		</section>
	);
};
